export function getCen() {
    return 'sdata/rest/service/dataapi/rest';
    // return 'http://47.104.207.2:18080/';
    // return 'http://10.20.220.179:8008/api/'; //昆华正式（内网）
    // return 'http://sm.ypfph.com:8008/api/'; //昆华正式（外网）
}
export function getImgBaseUrl() {
    return 'http://47.104.207.2:18082/';
}